import i18n from 'i18n-js';

import {
  AiEnding,
  AiEndingVideo,
  AiStarting,
  AiStartingVideo,
  BasketballEuroLeague,
  BasketballLebPlata,
  BasketballLigaEndesa,
  BasketballNba,
  BasketballSimple,
  BasketballSpanishCup,
  ControllerPs4,
  ControllerPs4Military,
  ControllerPs5,
  CountdownArtificialIntelligence,
  CountdownBattery,
  CountdownBomb,
  CountdownBoxingRing,
  CountdownChristmasBall,
  CountdownChristmasHat,
  CountdownChristmasPresent,
  CountdownCustomBackground,
  CountdownDigital,
  CountdownGenshin,
  CountdownGenshinSimple,
  CountdownHalloween,
  CountdownKarmaland,
  CountdownKingsLeague,
  CountdownLolWorlds,
  CountdownLolWorldsSimple,
  CountdownMinecraft,
  CountdownNeonSimple,
  CountdownNewWorld,
  CountdownSimple,
  CountdownSquidCraft,
  CountdownTheGrefg,
  CountdownTheGrefgDragonBall,
  CountdownWithoutBackground,
  GiveawaySimple,
  MediaLoopSimple,
  PadelSimple,
  PadelWorldPadelTour2021,
  QuestionSimple,
  QuestionTwitch,
  RouletteCasino,
  RouletteLogo,
  RouletteSimple,
  SoccerArgentinaLeague,
  SoccerArgentinaLeague2023,
  SoccerArgentinaPrimeraNacional2023,
  SoccerChampionsLeague,
  SoccerChampionsLeague2025,
  SoccerClubWorldCup2025,
  SoccerCopaAmerica2024,
  SoccerCopaRey,
  SoccerCopaRey2023,
  SoccerEuroCup2024,
  SoccerEuropaLeague,
  SoccerKingdomCup,
  SoccerKingsLeague,
  SoccerKingsLeague2split,
  SoccerKingsLeague3split,
  SoccerSimple,
  SoccerLaLiga,
  SoccerLaLigaEASports,
  SoccerLaLigaHypermotion,
  SoccerLaLigaSmartBank,
  SoccerLaLigue1,
  SoccerPremierLeague,
  SoccerPremierLeague2024,
  SoccerQueensLeague,
  SoccerSerieA,
  SoccerSupercopa2023,
  SoccerUefaEuro2020,
  SoccerWorldCup2022,
  SoccerWorldCup2022Official,
} from '../../components';

import { TEMPLATES_TITLES } from '../templates';

import { ALERTBOX_COMPONENTS, ALERTBOX_DESIGNS_DATA } from './alertBox';
import {
  AMERICANFOOTBALL_COMPONENTS,
  AMERICANFOOTBALL_DESIGNS_DATA,
} from './americanFootball';
import { BASEBALL_COMPONENTS, BASEBALL_DESIGNS_DATA } from './baseball';
import { CHAT_COMPONENTS, CHAT_DESIGNS_DATA } from './chat';
import { COINFLIP_COMPONENTS, COINFLIP_DESIGNS_DATA } from './coinFlip';
import { CONFETTI_COMPONENTS, CONFETTI_DESIGNS_DATA } from './confetti';
import { COUNT_UP_COMPONENTS, COUNT_UP_DESIGNS_DATA } from './countUp';
import { FORTNITE_COMPONENTS, FORTNITE_DESIGNS_DATA } from './fortnite';
import { GBEST_COMPONENTS, GBEST_DESIGNS_DATA } from './gbest';
import { ORE_ESPORTS_COMPONENTS, ORE_ESPORTS_DESIGNS_DATA } from './oreEsports';
import { PAMPLING_COMPONENTS, PAMPLING_DESIGNS_DATA } from './pampling';
import { QUIZ_COMPONENTS, QUIZ_DESIGNS_DATA } from './quiz';
import {
  WORDGUESSING_COMPONENTS,
  WORDGUESSING_DESIGNS_DATA,
} from './wordGuessing';

export const COMPONENTS = {
  ...ALERTBOX_COMPONENTS,
  ...AMERICANFOOTBALL_COMPONENTS,
  ...BASEBALL_COMPONENTS,
  ...CHAT_COMPONENTS,
  ...COINFLIP_COMPONENTS,
  ...CONFETTI_COMPONENTS,
  ...COUNT_UP_COMPONENTS,
  ...FORTNITE_COMPONENTS,
  ...GBEST_COMPONENTS,
  ...ORE_ESPORTS_COMPONENTS,
  ...PAMPLING_COMPONENTS,
  ...QUIZ_COMPONENTS,
  ...WORDGUESSING_COMPONENTS,
  [TEMPLATES_TITLES.AI_ENDING]: AiEnding,
  [TEMPLATES_TITLES.AI_ENDING_VIDEO]: AiEndingVideo,
  [TEMPLATES_TITLES.AI_STARTING]: AiStarting,
  [TEMPLATES_TITLES.AI_STARTING_VIDEO]: AiStartingVideo,
  [TEMPLATES_TITLES.BASKETBALL_EUROLEAGUE]: BasketballEuroLeague,
  [TEMPLATES_TITLES.BASKETBALL_LEBPLATA]: BasketballLebPlata,
  [TEMPLATES_TITLES.BASKETBALL_LIGAENDESA]: BasketballLigaEndesa,
  [TEMPLATES_TITLES.BASKETBALL_NBA]: BasketballNba,
  [TEMPLATES_TITLES.BASKETBALL_SIMPLE]: BasketballSimple,
  [TEMPLATES_TITLES.BASKETBALL_SPANISHCUP]: BasketballSpanishCup,
  [TEMPLATES_TITLES.CONTROLLER_PS4]: ControllerPs4,
  [TEMPLATES_TITLES.CONTROLLER_PS4MILITARY]: ControllerPs4Military,
  [TEMPLATES_TITLES.CONTROLLER_PS5]: ControllerPs5,
  [TEMPLATES_TITLES.COUNTDOWN_ARTIFICIALINTELLIGENCE]:
    CountdownArtificialIntelligence,
  [TEMPLATES_TITLES.COUNTDOWN_BATTERY]: CountdownBattery,
  [TEMPLATES_TITLES.COUNTDOWN_BOMB]: CountdownBomb,
  [TEMPLATES_TITLES.COUNTDOWN_BOXINGRING]: CountdownBoxingRing,
  [TEMPLATES_TITLES.COUNTDOWN_CHRISTMASBALL]: CountdownChristmasBall,
  [TEMPLATES_TITLES.COUNTDOWN_CHRISTMASHAT]: CountdownChristmasHat,
  [TEMPLATES_TITLES.COUNTDOWN_CHRISTMASPRESENT]: CountdownChristmasPresent,
  [TEMPLATES_TITLES.COUNTDOWN_CUSTOMBACKGROUND]: CountdownCustomBackground,
  [TEMPLATES_TITLES.COUNTDOWN_DIGITAL]: CountdownDigital,
  [TEMPLATES_TITLES.COUNTDOWN_GENSHIN]: CountdownGenshin,
  [TEMPLATES_TITLES.COUNTDOWN_GENSHINSIMPLE]: CountdownGenshinSimple,
  [TEMPLATES_TITLES.COUNTDOWN_HALLOWEEN]: CountdownHalloween,
  [TEMPLATES_TITLES.COUNTDOWN_KARMALAND]: CountdownKarmaland,
  [TEMPLATES_TITLES.COUNTDOWN_KINGSLEAGUE]: CountdownKingsLeague,
  [TEMPLATES_TITLES.COUNTDOWN_LOLWORLDS]: CountdownLolWorlds,
  [TEMPLATES_TITLES.COUNTDOWN_LOLWORLDSSIMPLE]: CountdownLolWorldsSimple,
  [TEMPLATES_TITLES.COUNTDOWN_MINECRAFT]: CountdownMinecraft,
  [TEMPLATES_TITLES.COUNTDOWN_NEONSIMPLE]: CountdownNeonSimple,
  [TEMPLATES_TITLES.COUNTDOWN_NEWWORLD]: CountdownNewWorld,
  [TEMPLATES_TITLES.COUNTDOWN_SIMPLE]: CountdownSimple,
  [TEMPLATES_TITLES.COUNTDOWN_SQUIDCRAFT]: CountdownSquidCraft,
  [TEMPLATES_TITLES.COUNTDOWN_THEGREFG]: CountdownTheGrefg,
  [TEMPLATES_TITLES.COUNTDOWN_THEGREFGDRAGONBALL]: CountdownTheGrefgDragonBall,
  [TEMPLATES_TITLES.COUNTDOWN_WITHOUTBACKGROUND]: CountdownWithoutBackground,
  [TEMPLATES_TITLES.GIVEAWAY_SIMPLE]: GiveawaySimple,
  [TEMPLATES_TITLES.MEDIALOOP_SIMPLE]: MediaLoopSimple,
  [TEMPLATES_TITLES.MEDIALOOP_SOCIALMEDIA]: MediaLoopSimple,
  [TEMPLATES_TITLES.PADEL_SIMPLE]: PadelSimple,
  [TEMPLATES_TITLES.PADEL_WORLD_PADEL_TOUR_2021]: PadelWorldPadelTour2021,
  [TEMPLATES_TITLES.QUESTION_SIMPLE]: QuestionSimple,
  [TEMPLATES_TITLES.QUESTION_TWITCH]: QuestionTwitch,
  [TEMPLATES_TITLES.ROULETTE_CASINO]: RouletteCasino,
  [TEMPLATES_TITLES.ROULETTE_LOGO]: RouletteLogo,
  [TEMPLATES_TITLES.ROULETTE_SIMPLE]: RouletteSimple,
  [TEMPLATES_TITLES.SOCCER_ARGENTINALEAGUE]: SoccerArgentinaLeague,
  [TEMPLATES_TITLES.SOCCER_ARGENTINALEAGUE2023]: SoccerArgentinaLeague2023,
  [TEMPLATES_TITLES.SOCCER_ARGENTINAPRIMERANACIONAL2023]:
    SoccerArgentinaPrimeraNacional2023,
  [TEMPLATES_TITLES.SOCCER_CHAMPIONSLEAGUE]: SoccerChampionsLeague,
  [TEMPLATES_TITLES.SOCCER_CHAMPIONSLEAGUE2025]: SoccerChampionsLeague2025,
  [TEMPLATES_TITLES.SOCCER_CLUBWORLDCUP2025]: SoccerClubWorldCup2025,
  [TEMPLATES_TITLES.SOCCER_COPAAMERICA2024]: SoccerCopaAmerica2024,
  [TEMPLATES_TITLES.SOCCER_COPAREY]: SoccerCopaRey,
  [TEMPLATES_TITLES.SOCCER_COPAREY2023]: SoccerCopaRey2023,
  [TEMPLATES_TITLES.SOCCER_EUROCUP2024]: SoccerEuroCup2024,
  [TEMPLATES_TITLES.SOCCER_EUROPALEAGUE]: SoccerEuropaLeague,
  [TEMPLATES_TITLES.SOCCER_KINGDOMCUP]: SoccerKingdomCup,
  [TEMPLATES_TITLES.SOCCER_KINGSLEAGUE]: SoccerKingsLeague,
  [TEMPLATES_TITLES.SOCCER_KINGSLEAGUE2SPLIT]: SoccerKingsLeague2split,
  [TEMPLATES_TITLES.SOCCER_KINGSLEAGUE3SPLIT]: SoccerKingsLeague3split,
  [TEMPLATES_TITLES.SOCCER_SIMPLE]: SoccerSimple,
  [TEMPLATES_TITLES.SOCCER_LALIGA]: SoccerLaLiga,
  [TEMPLATES_TITLES.SOCCER_LALIGAEASPORTS]: SoccerLaLigaEASports,
  [TEMPLATES_TITLES.SOCCER_LALIGAHYPERMOTION]: SoccerLaLigaHypermotion,
  [TEMPLATES_TITLES.SOCCER_LALIGASMARTBANK]: SoccerLaLigaSmartBank,
  [TEMPLATES_TITLES.SOCCER_LALIGUE1]: SoccerLaLigue1,
  [TEMPLATES_TITLES.SOCCER_PREMIERLEAGUE]: SoccerPremierLeague,
  [TEMPLATES_TITLES.SOCCER_PREMIERLEAGUE2024]: SoccerPremierLeague2024,
  [TEMPLATES_TITLES.SOCCER_QUEENSLEAGUE]: SoccerQueensLeague,
  [TEMPLATES_TITLES.SOCCER_SERIEA]: SoccerSerieA,
  [TEMPLATES_TITLES.SOCCER_SUPERCOPA2023]: SoccerSupercopa2023,
  [TEMPLATES_TITLES.SOCCER_EUFA_EURO_2020]: SoccerUefaEuro2020,
  [TEMPLATES_TITLES.SOCCER_WORLDCUP2022]: SoccerWorldCup2022,
  [TEMPLATES_TITLES.SOCCER_WORLDCUP2022OFFICIAL]: SoccerWorldCup2022Official,
};

export const DESIGNS_DATA = {
  ...ALERTBOX_DESIGNS_DATA,
  ...AMERICANFOOTBALL_DESIGNS_DATA,
  ...BASEBALL_DESIGNS_DATA,
  ...CHAT_DESIGNS_DATA,
  ...COINFLIP_DESIGNS_DATA,
  ...CONFETTI_DESIGNS_DATA,
  ...COUNT_UP_DESIGNS_DATA,
  ...FORTNITE_DESIGNS_DATA,
  ...GBEST_DESIGNS_DATA,
  ...ORE_ESPORTS_DESIGNS_DATA,
  ...PAMPLING_DESIGNS_DATA,
  ...QUIZ_DESIGNS_DATA,
  ...WORDGUESSING_DESIGNS_DATA,
  [TEMPLATES_TITLES.BASKETBALL_EUROLEAGUE]: {
    design: {
      hasTeamLogo: true,
    },
  },
  [TEMPLATES_TITLES.BASKETBALL_LEBPLATA]: {
    design: {},
  },
  [TEMPLATES_TITLES.BASKETBALL_LIGAENDESA]: {
    design: {},
  },
  [TEMPLATES_TITLES.BASKETBALL_NBA]: {
    design: {
      hasTeamLogo: true,
    },
  },
  [TEMPLATES_TITLES.BASKETBALL_SIMPLE]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.pointsDesign'),
          value: 'points',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.teamNamesDesign'),
          value: 'teamName',
          items: [
            {
              id: 102,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 3,
          title: i18n.t('screens.builder.design.timerDesign'),
          value: 'timer',
          items: [
            {
              id: 104,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 105,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 4,
          title: i18n.t('screens.builder.design.quarterDesign'),
          value: 'quarter',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.BASKETBALL_SPANISHCUP]: {
    design: {},
  },
  [TEMPLATES_TITLES.CONTROLLER_PS4]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.bodyColor'),
          value: 'body',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.legsColor'),
          value: 'legs',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
          ],
        },
        {
          id: 3,
          title: i18n.t('screens.builder.design.buttonsColor'),
          value: 'buttons',
          items: [
            {
              id: 300,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 301,
              label: i18n.t('screens.builder.design.buttonColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 4,
          title: i18n.t('screens.builder.design.backButtons'),
          value: 'backButtons',
          items: [
            {
              id: 400,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
          ],
        },
        {
          id: 5,
          title: i18n.t('screens.builder.design.arrowsColor'),
          value: 'arrows',
          items: [
            {
              id: 500,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 501,
              label: i18n.t('screens.builder.design.outerArrowsColor'),
              type: 'color',
              value: 'border',
            },
            {
              id: 502,
              label: i18n.t('screens.builder.design.arrowsColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 6,
          title: i18n.t('screens.builder.design.sticksColor'),
          value: 'sticks',
          items: [
            {
              id: 600,
              label: i18n.t('screens.builder.design.outsideColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 601,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'border',
            },
            {
              id: 602,
              label: i18n.t('screens.builder.design.insideColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 7,
          title: i18n.t('screens.builder.design.optionButtons'),
          value: 'options',
          items: [
            {
              id: 700,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
          ],
        },
        {
          id: 8,
          title: i18n.t('screens.builder.design.psButton'),
          value: 'ps',
          items: [
            {
              id: 800,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 801,
              label: i18n.t('screens.builder.design.psColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 9,
          title: i18n.t('screens.builder.design.touchPanel'),
          value: 'touchpad',
          items: [
            {
              id: 900,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
          ],
        },
        {
          id: 10,
          title: i18n.t('screens.builder.design.activatedButton'),
          value: 'active',
          items: [
            {
              id: 1000,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.CONTROLLER_PS4MILITARY]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.legsColor'),
          value: 'legs',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.buttonsColor'),
          value: 'buttons',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.buttonColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 3,
          title: i18n.t('screens.builder.design.backButtons'),
          value: 'backButtons',
          items: [
            {
              id: 300,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
          ],
        },
        {
          id: 4,
          title: i18n.t('screens.builder.design.arrowsColor'),
          value: 'arrows',
          items: [
            {
              id: 400,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 401,
              label: i18n.t('screens.builder.design.outerArrowsColor'),
              type: 'color',
              value: 'border',
            },
            {
              id: 402,
              label: i18n.t('screens.builder.design.arrowsColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 5,
          title: i18n.t('screens.builder.design.sticksColor'),
          value: 'sticks',
          items: [
            {
              id: 500,
              label: i18n.t('screens.builder.design.outsideColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 501,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'border',
            },
            {
              id: 502,
              label: i18n.t('screens.builder.design.insideColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 6,
          title: i18n.t('screens.builder.design.optionButtons'),
          value: 'options',
          items: [
            {
              id: 600,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
          ],
        },
        {
          id: 7,
          title: i18n.t('screens.builder.design.psButton'),
          value: 'ps',
          items: [
            {
              id: 700,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 701,
              label: i18n.t('screens.builder.design.psColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 8,
          title: i18n.t('screens.builder.design.touchPanel'),
          value: 'touchpad',
          items: [
            {
              id: 800,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
          ],
        },
        {
          id: 9,
          title: i18n.t('screens.builder.design.activatedButton'),
          value: 'active',
          items: [
            {
              id: 900,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.CONTROLLER_PS5]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.bodyColor'),
          value: 'body',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'background',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.buttonsColor'),
          value: 'buttons',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.buttonColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'border',
            },
          ],
        },
        {
          id: 3,
          title: i18n.t('screens.builder.design.backButtons'),
          value: 'backButtons',
          items: [
            {
              id: 300,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
          ],
        },
        {
          id: 4,
          title: i18n.t('screens.builder.design.arrowsColor'),
          value: 'arrows',
          items: [
            {
              id: 400,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'border',
            },
            {
              id: 401,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 5,
          title: i18n.t('screens.builder.design.sticksColor'),
          value: 'sticks',
          items: [
            {
              id: 500,
              label: i18n.t('screens.builder.design.outsideColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 501,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'border',
            },
            {
              id: 502,
              label: i18n.t('screens.builder.design.insideColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 6,
          title: i18n.t('screens.builder.design.optionButtons'),
          value: 'options',
          items: [
            {
              id: 600,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 601,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'border',
            },
          ],
        },
        {
          id: 7,
          title: i18n.t('screens.builder.design.psButton'),
          value: 'ps',
          items: [
            {
              id: 700,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 701,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'border',
            },
          ],
        },
        {
          id: 8,
          title: i18n.t('screens.builder.design.touchPanel'),
          value: 'touchpad',
          items: [
            {
              id: 800,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 801,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'border',
            },
          ],
        },
        {
          id: 9,
          title: i18n.t('screens.builder.design.activatedButton'),
          value: 'active',
          items: [
            {
              id: 900,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNTDOWN_ARTIFICIALINTELLIGENCE]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.background'),
          value: 'background',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundImageAI'),
              type: 'ai',
              value: 'url',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 5,
              max: 100,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
            {
              id: 206,
              label: i18n.t('screens.builder.design.moveHorizontally'),
              min: -300,
              max: 300,
              step: 1,
              type: 'slider',
              value: 'x',
            },
            {
              id: 207,
              label: i18n.t('screens.builder.design.moveVertically'),
              min: -300,
              max: 300,
              step: 1,
              type: 'slider',
              value: 'y',
            },
          ],
        },
        {
          id: 3,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 300,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 301,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 302,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 10,
              max: 120,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 303,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
            {
              id: 304,
              label: i18n.t('screens.builder.design.moveHorizontally'),
              min: -300,
              max: 300,
              step: 1,
              type: 'slider',
              value: 'x',
            },
            {
              id: 305,
              label: i18n.t('screens.builder.design.moveVertically'),
              min: -300,
              max: 300,
              step: 1,
              type: 'slider',
              value: 'y',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNTDOWN_BATTERY]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 80,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 10,
              max: 30,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNTDOWN_BOMB]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 10,
              max: 50,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 104,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 10,
              max: 40,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNTDOWN_BOXINGRING]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'border',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 104,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 100,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 105,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 60,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNTDOWN_CHRISTMASBALL]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 40,
              max: 110,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 80,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNTDOWN_CHRISTMASHAT]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 40,
              max: 120,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'border',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 60,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 204,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNTDOWN_CHRISTMASPRESENT]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 40,
              max: 120,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 100,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNTDOWN_SIMPLE]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 100,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 104,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 10,
              max: 60,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 204,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNTDOWN_CUSTOMBACKGROUND]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.background'),
          value: 'background',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundImage'),
              type: 'image',
              value: 'url',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 5,
              max: 100,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
            {
              id: 206,
              label: i18n.t('screens.builder.design.moveHorizontally'),
              min: -300,
              max: 300,
              step: 1,
              type: 'slider',
              value: 'x',
            },
            {
              id: 207,
              label: i18n.t('screens.builder.design.moveVertically'),
              min: -300,
              max: 300,
              step: 1,
              type: 'slider',
              value: 'y',
            },
          ],
        },
        {
          id: 3,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 300,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 301,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 302,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 10,
              max: 120,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 303,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
            {
              id: 304,
              label: i18n.t('screens.builder.design.moveHorizontally'),
              min: -300,
              max: 300,
              step: 1,
              type: 'slider',
              value: 'x',
            },
            {
              id: 305,
              label: i18n.t('screens.builder.design.moveVertically'),
              min: -300,
              max: 300,
              step: 1,
              type: 'slider',
              value: 'y',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNTDOWN_DIGITAL]: {
    design: {
      hasLogo: true,
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'border',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 104,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 40,
              max: 120,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 105,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 70,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNTDOWN_GENSHIN]: {
    design: {},
  },
  [TEMPLATES_TITLES.COUNTDOWN_GENSHINSIMPLE]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 80,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 80,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNTDOWN_HALLOWEEN]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 30,
              max: 90,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 104,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 80,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNTDOWN_KARMALAND]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 100,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 104,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 80,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNTDOWN_KINGSLEAGUE]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'border',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 104,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 100,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 105,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 80,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNTDOWN_LOLWORLDS]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNTDOWN_LOLWORLDSSIMPLE]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.logo'),
          value: 'logo',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
          ],
        },
        {
          id: 3,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 300,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 301,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNTDOWN_MINECRAFT]: {
    design: {
      hasLogo: true,
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 100,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 104,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 80,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNTDOWN_NEONSIMPLE]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 100,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 80,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 3,
          title: i18n.t('screens.builder.design.backgroundImage'),
          value: 'background',
          items: [
            {
              id: 300,
              label: i18n.t('screens.builder.design.backgroundImage'),
              type: 'checkbox',
              value: 'hasBackground',
            },
            {
              id: 301,
              label: i18n.t('screens.builder.design.borderRadius'),
              min: 0,
              max: 100,
              step: 2,
              type: 'slider',
              value: 'borderRadius',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNTDOWN_NEWWORLD]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNTDOWN_SQUIDCRAFT]: {
    design: {
      hasLogo: true,
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 100,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 80,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNTDOWN_THEGREFG]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 40,
              max: 120,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'border',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 100,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 204,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 3,
          title: i18n.t('screens.builder.design.ballsOfPower'),
          value: 'balls',
          items: [
            {
              id: 300,
              label: i18n.t('screens.builder.design.visible'),
              type: 'checkbox',
              value: 'show',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNTDOWN_THEGREFGDRAGONBALL]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'border',
            },
            {
              id: 100,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 40,
              max: 120,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNTDOWN_WITHOUTBACKGROUND]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 80,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 40,
              max: 120,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.GIVEAWAY_SIMPLE]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.title'),
          value: 'text',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 100,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.users'),
          value: 'username',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.MEDIALOOP_SIMPLE]: {
    design: {},
  },
  [TEMPLATES_TITLES.MEDIALOOP_SOCIALMEDIA]: {
    design: {},
  },
  [TEMPLATES_TITLES.PADEL_SIMPLE]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.teamNamesDesign'),
          value: 'teamName',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.gamesDesign'),
          value: 'games',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 3,
          title: i18n.t('screens.builder.design.pointsDesign'),
          value: 'points',
          items: [
            {
              id: 300,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 301,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.PADEL_WORLD_PADEL_TOUR_2021]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.container'),
          value: 'container',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'border',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.activateColor'),
              type: 'color',
              value: 'active',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.activateColor'),
          value: 'active',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'border',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.QUESTION_SIMPLE]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.question'),
          value: 'text',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 80,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.username'),
          value: 'username',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 40,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 3,
          title: i18n.t('screens.builder.design.container'),
          value: 'question',
          items: [
            {
              id: 300,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.QUESTION_TWITCH]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.question'),
          value: 'text',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 80,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 104,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.username'),
          value: 'username',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 10,
              max: 50,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 204,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.ROULETTE_CASINO]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.selector'),
          value: 'selector',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.image'),
          value: 'image',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.visible'),
              type: 'checkbox',
              value: 'show',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.ROULETTE_LOGO]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.selector'),
          value: 'selector',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.container'),
          value: 'container',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.ROULETTE_SIMPLE]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.selector'),
          value: 'selector',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.container'),
          value: 'container',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.SOCCER_ARGENTINALEAGUE]: {
    design: {},
  },
  [TEMPLATES_TITLES.SOCCER_ARGENTINALEAGUE2023]: {
    design: {},
  },
  [TEMPLATES_TITLES.SOCCER_ARGENTINAPRIMERANACIONAL2023]: {
    design: {},
  },
  [TEMPLATES_TITLES.SOCCER_CHAMPIONSLEAGUE]: {
    design: {},
  },
  [TEMPLATES_TITLES.SOCCER_CHAMPIONSLEAGUE2025]: {
    design: {},
  },
  [TEMPLATES_TITLES.SOCCER_CLUBWORLDCUP2025]: {
    design: {
      hasTeamLogo: true,
    },
  },
  [TEMPLATES_TITLES.SOCCER_COPAAMERICA2024]: {
    design: {},
  },
  [TEMPLATES_TITLES.SOCCER_COPAREY]: {
    design: {},
  },
  [TEMPLATES_TITLES.SOCCER_COPAREY2023]: {
    design: {},
  },
  [TEMPLATES_TITLES.SOCCER_EUROCUP2024]: {
    design: {},
  },
  [TEMPLATES_TITLES.SOCCER_EUROPALEAGUE]: {
    design: {},
  },
  [TEMPLATES_TITLES.SOCCER_KINGDOMCUP]: {
    design: {
      hasTeamLogo: true,
    },
  },
  [TEMPLATES_TITLES.SOCCER_KINGSLEAGUE]: {
    design: {
      hasTeamLogo: true,
    },
  },
  [TEMPLATES_TITLES.SOCCER_KINGSLEAGUE2SPLIT]: {
    design: {
      hasTeamLogo: true,
    },
  },
  [TEMPLATES_TITLES.SOCCER_KINGSLEAGUE3SPLIT]: {
    design: {
      hasTeamLogo: true,
    },
  },
  [TEMPLATES_TITLES.SOCCER_SIMPLE]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.pointsDesign'),
          value: 'points',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.teamNamesDesign'),
          value: 'teamName',
          items: [
            {
              id: 102,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 3,
          title: i18n.t('screens.builder.design.timerDesign'),
          value: 'timer',
          items: [
            {
              id: 104,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 105,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.SOCCER_LALIGA]: {
    design: {},
  },
  [TEMPLATES_TITLES.SOCCER_LALIGAEASPORTS]: {
    design: {
      hasTeamLogo: true,
    },
  },
  [TEMPLATES_TITLES.SOCCER_LALIGAHYPERMOTION]: {
    design: {
      hasTeamLogo: true,
    },
  },
  [TEMPLATES_TITLES.SOCCER_LALIGASMARTBANK]: {
    design: {},
  },
  [TEMPLATES_TITLES.SOCCER_LALIGUE1]: {
    design: {},
  },
  [TEMPLATES_TITLES.SOCCER_PREMIERLEAGUE]: {
    design: {},
  },
  [TEMPLATES_TITLES.SOCCER_PREMIERLEAGUE2024]: {
    design: {},
  },
  [TEMPLATES_TITLES.SOCCER_QUEENSLEAGUE]: {
    design: {
      hasTeamLogo: true,
    },
  },
  [TEMPLATES_TITLES.SOCCER_SERIEA]: {
    design: {},
  },
  [TEMPLATES_TITLES.SOCCER_SUPERCOPA2023]: {
    design: {},
  },
  [TEMPLATES_TITLES.SOCCER_EUFA_EURO_2020]: {
    design: {},
  },
  [TEMPLATES_TITLES.SOCCER_WORLDCUP2022]: {
    design: {
      hasTeamLogo: true,
    },
  },
  [TEMPLATES_TITLES.SOCCER_WORLDCUP2022OFFICIAL]: {
    design: {
      hasTeamLogo: true,
    },
  },
};

export default {
  COMPONENTS,
  DESIGNS_DATA,
};
